import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicSummary = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="SUMMARY"
      takeaways={[
        
        { text: "You may get two problems,one from laplace transform and one from inverse laplace transform" },
        { text: "Concentrate more on laplace of periodic functions and solving inverse laplace transform using convolution theorem." },
        { text: "Frequently used formulas" ,
          image: "/lp_5.png"},

      ]}
      videos={[]} // No videos provided
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicSummary;
